import env from 'enviro';
import { lazy, Suspense } from 'react';
import { getIsQAProxy } from '../../utils/envUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const LazyPublicDebugPanel = /*#__PURE__*/lazy(() => import( /* webpackChunkName: "public-debug-panel" */'./PublicDebugPanel'));
const AsyncPublicDebugPanel = () => {
  const isQA = env.isQa() || getIsQAProxy();
  if (!isQA) return null;
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: null,
    children: /*#__PURE__*/_jsx(LazyPublicDebugPanel, {})
  });
};
export default AsyncPublicDebugPanel;